import * as Api from "@api";
import * as C from "@components";
import React from "react";
import { ProductSpecification, ProductSpecificationProps, ProductSpecificationKeys } from '@/parts';
import css from "./product-specification-section.module.scss";
import SketchFabProductSpinner from "./SketchfabProductSpinner";

export const ProductSpecificationSectionKeys = [
    "specification.productTitle",
    "specification.productDescription",
    "specification.list",
    ...ProductSpecificationKeys,
    "specification.getSamples",
    ["specification.getSamplesMobile"],
] as const;

interface ProductSpecificationSectionProps extends Omit<ProductSpecificationProps<never>, "pageContent">
{
    extraContent?: React.ReactNode;
    pageContent: Api.Content<typeof ProductSpecificationSectionKeys[number]>;
    product: Api.ProductFull;
    productImage?: React.ReactNode;
    productSketchFabId?: string;
    isSpinnerBeforeBullets?: boolean;
    isList?: boolean;
}

export const ProductSpecificationSection = ({ extraContent, pageContent, product, productImage, productSketchFabId, isList = false, isSpinnerBeforeBullets = false, ...props }: ProductSpecificationSectionProps): React.FunctionComponentElement<ProductSpecificationSectionProps> =>
{
    return (
        <C.PageSection className={`${css["section"]} flex-col ${isList ? 'md:flex-row-reverse' : 'md:flex-row'} relative`}>
            <div className={`${css["wrapper"]}`}>
                <C.ProductTitle className={`${css["product-title"]} [&>h5]:leading-9`} product={product} titleContentProps={{ ...pageContent["specification.productTitle"] }} />
                <p className="mb-10 text-[18px]">
                    {pageContent["specification.productDescription"]?.data}</p>
                <SketchFabProductSpinner
                    product={product}
                    productImage={productImage}
                    productSketchFabId={productSketchFabId}
                    className={isList ? 'block md:hidden mb-6' : 'hidden'}
                />
                {
                    isList
                        ? <>
                            <div
                                className={css['product-specification-list']}
                                dangerouslySetInnerHTML={{ __html: pageContent['specification.list']?.data ?? '<ul></ul>' }}
                            />
                        </>
                        : <>
                            <ProductSpecification {...props} pageContent={pageContent} />
                            {extraContent}
                        </>
                }
                <C.PageLink className={`${css["get-samples"]} w-fit`} data-hidden-on-mobile href="#contact-us" data-logic-feature="scroll-to" data-scroll-to="contact-us" variant={C.PageLinkVariant.NewButton} title={pageContent["specification.getSamples"]?.data ?? "Get samples"}>
                    {pageContent["specification.getSamples"]?.data ?? "Get samples"}
                </C.PageLink>
                <C.PageLink className={css["get-samples"]} data-hidden-on-desktop href="#contact-us" data-logic-feature="scroll-to" data-scroll-to="contact-us" variant={C.PageLinkVariant.NewButton} title={pageContent["specification.getSamplesMobile"]?.data ?? "Get samples"}>
                    {pageContent["specification.getSamplesMobile"]?.data ?? "Get samples"}
                </C.PageLink>
            </div>
            <SketchFabProductSpinner
                product={product}
                productImage={productImage}
                productSketchFabId={productSketchFabId}
                className={isList ? 'hidden md:block' : ''}
            />
        </C.PageSection>
    );
}
